var _defs, _path, _line, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #000;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n\n      .cls-2 {\n        stroke-linecap: round;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m59.25,19.41v42.31c0,2.46-1.84,4.45-4.12,4.45H19.87c-2.27,0-4.12-1.99-4.12-4.45V19.41"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 7.7,
    y1: 19.41,
    x2: 67.3,
    y2: 19.41
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m45.93,18.75v-6.94c0-1.64-1.51-2.98-3.37-2.98h-10.12c-1.86,0-3.37,1.33-3.37,2.98v6.94"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 29.07,
    y1: 30.99,
    x2: 29.07,
    y2: 54.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 45.93,
    y1: 30.99,
    x2: 45.93,
    y2: 54.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteRemove);
export default __webpack_public_path__ + "static/media/__Delete - Remove.79799392c7ee913d7e2d2f031c9f2afd.svg";
export { ForwardRef as ReactComponent };